<template>
  <div>
    <v-card>
      <v-card-title>
        <h5>Shipped Orders by Monthly</h5>
      </v-card-title>
      <v-card-text>
        <line-chart :data="ordersData"></line-chart>
      </v-card-text>
    </v-card>

    <v-card>
      <v-card-title>
        <h5>User Count by Monthly</h5>
      </v-card-title>
      <v-card-text>
        <line-chart :data="usersData"></line-chart>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import api from '@/api/gungho'

export default {
  data () {
    return {
      ordersData: {},
      usersData: {}
    }
  },

  beforeMount () {
    api.reportsShippedOrders().then((data) => { this.ordersData = data })
    api.reportsUsersAdded().then((data) => { this.usersData = data })
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?5df64548